document.addEventListener('DOMContentLoaded', function() {
  const variantSelector = document.querySelector('[name="id"]');
  const skuDisplay = document.querySelector('.product-sku');

  if (variantSelector && skuDisplay) {
    variantSelector.addEventListener('change', function() {
      const selectedVariantId = variantSelector.value;
      const selectedVariant = window.productVariants.find(variant => variant.id == selectedVariantId);

      if (selectedVariant) {
        skuDisplay.textContent = selectedVariant.sku;
      }
    });
  }
});








